var currentDate = new Date();
var currentDay = currentDate.getDay();
var addDays = function (date, numberOfDays) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
};
var isAnOffsetDay = function (date, offset) {
    var offsetDay = addDays(currentDate, offset);
    return date.getDate() === offsetDay.getDate() && date.getMonth() === offsetDay.getMonth() && date.getFullYear() === offsetDay.getFullYear();
};
var dateIsInWeek = function (date) {
    var beginningOfTheWeek = addDays(currentDate, -currentDay);
    var endOfTheWeek = addDays(currentDate, 7 - currentDay);
    return beginningOfTheWeek <= date && date <= endOfTheWeek;
};
var dateIsInYear = function (date) {
    var beginningOfTheYear = new Date(currentDate.getFullYear(), 0);
    var endOfTheYear = new Date(currentDate.getFullYear(), 11, 31);
    return beginningOfTheYear <= date && date <= endOfTheYear;
};
/**
 * Format DateTime into user friendly date format
 * @param {Date} date: A Date object that represents a certain date
 * @returns {String}: Formatted date
 */
export var formatDateToFriendly = function (date) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    switch (true) {
        case isAnOffsetDay(date, 0):
            return 'Today';
        case isAnOffsetDay(date, -1):
            return 'Yesterday';
        case isAnOffsetDay(date, 1):
            return 'Tomorrow';
        case dateIsInWeek(date) && date < currentDate:
            return "Last " + days[date.getDay()];
        case dateIsInWeek(date):
            return days[date.getDay()];
        case !dateIsInWeek(date) && dateIsInYear(date):
            return months[date.getMonth()] + " " + date.getDate();
        default:
            return months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
    }
};
export default formatDateToFriendly;
//# sourceMappingURL=formatDateToFriendly.js.map